import fetch from "cross-fetch";
import { useRouter } from "next/dist/client/router";
import { useQuery } from "react-query";
import settings from "src/settings";
const { API_BACKEND_HOSTNAME } = settings;

/**
 * React Query hook to fetch an entry's leagues.
 * @example
 * import useLeague from "@hooks/useLeague";
 * ...
 * const { data } = useLeague();
 * const { leagues } = data;
 */
export default function useLeague(pageNumber: number) {
  const router = useRouter();
  const leagueId = Number(router.query.id);

  return useQuery<LeagueResponse, Error>(
    ["league", leagueId, `${pageNumber}.json`],
    () =>
      fetch(`${API_BACKEND_HOSTNAME}/api/v1/chase/leagues/${leagueId}/page/${pageNumber}.json`, {
        headers: { "content-type": "application/json" },
        method: "GET",
      }).then((res) => res.json()),
    {
      enabled: Boolean(leagueId && pageNumber),
      retry: 2,
      initialData: {
        league: {
          id: null,
          creator_id: null,
          name: null,
          memberships_count: null,
          is_private: null,
          motto: null,
        },
        memberships: [],
        pagination: {
          has_next: false,
          has_previous: false,
          page: 1,
          pages: 1,
          per_page: 50,
        },
      },
    },
  );
}

export interface LeagueResponse {
  league: ILeague;
  memberships: LeagueMember[];
  pagination: Pagination;
}

export interface ILeague {
  creator_id: number;
  id: number;
  is_private: boolean;
  memberships_count: number;
  motto: string;
  name: string;
}

export interface LeagueMember {
  avatar_id: number;
  id: number;
  name: string;
  percentile: number;
  points: number;
  rank: string;
}

interface Pagination {
  has_next: boolean;
  has_previous: boolean;
  page: number;
  pages: number;
  per_page: number;
}
